import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseAppState,
  ModalsActions,
  SurveyApiActions,
  SurveySelectors,
  goToSurvey,
} from 'ngx-esprio-shared';
import { take } from 'rxjs';

/**
 * Floating action button on the dashboard (ticket 27757). A "+" button that
 * expands a small menu with three quick actions: start a survey, enter weight,
 * capture a meal.
 */
@Component({
  selector: 'app-dashboard-fab',
  templateUrl: './dashboard-fab.component.html',
  styleUrls: ['./dashboard-fab.component.scss'],
})
export class DashboardFabComponent {
  public open = false;

  private readonly surveys$ = this.store.select(SurveySelectors.getSurveys);

  public constructor(
    private readonly store: Store<BaseAppState>,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  public toggle(): void {
    this.open = !this.open;
  }

  public close(): void {
    this.open = false;
  }

  public startSurvey(): void {
    this.close();
    this.surveys$.pipe(take(1)).subscribe((surveys) => {
      const survey = surveys?.find(
        (s) => s.familyName !== 'on-demand-baseline' && s.familyName !== 'on-demand-baselineWebk'
      );
      if (!survey) {
        return;
      }
      if (!survey.continuedSubmissionId) {
        this.store.dispatch(
          SurveyApiActions.createSubmission({
            scheduleId: survey.scheduleId,
            surveyId: survey.id,
          })
        );
      } else {
        this.store.dispatch(goToSurvey({ submissionId: survey.continuedSubmissionId }));
      }
    });
  }

  public enterWeight(): void {
    this.close();
    this.store.dispatch(ModalsActions.OpenAddWeightDataModal());
  }

  public addMeal(): void {
    this.close();
    this.document
      .getElementById('nutrition-diary-card')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
